module.exports = __webpack_public_path__ + "img/GAME_BEAUTIFULFLOWER1.fc75ad4b.jpg";